import { Link } from 'react-router-dom';

const stats = [
  { value: '30+', label: '收录影片' },
  { value: '40+', label: '深度影评' },
  { value: '5', label: '主题专题' },
  { value: '20+', label: '行业资讯' },
];

export default function SiteIntro() {
  return (
    <section className="mt-14 rounded-lg bg-primary-900 text-background-50 overflow-hidden">
      <div className="grid grid-cols-1 lg:grid-cols-2">
        <div className="p-6 md:p-10">
          <p className="font-label text-xs font-semibold uppercase tracking-[0.2em] text-accent-400">
            About Korean Cinema Review
          </p>
          <h2 className="mt-3 font-heading text-2xl md:text-3xl font-extrabold leading-snug">
            以杂志编辑的方式
            <br className="hidden md:block" />
            读懂韩国电影
          </h2>
          <p className="mt-4 text-sm md:text-base leading-relaxed text-background-200/85">
            「韩国理论片」专注于收集与介绍最新的韩国剧情类电影与理论电影。我们不只提供影片基本信息，更通过影评解析与主题专题，
            帮助影迷理解作品背后的社会语境、影像语言与作者思考，把一次观影变成一段有深度的阅读。
          </p>
          <div className="mt-6 flex flex-wrap gap-3">
            <Link
              to="/about"
              className="inline-flex items-center gap-2 h-11 px-5 rounded-md bg-accent-500 font-label text-sm font-semibold text-primary-950 hover:bg-accent-400 transition-colors whitespace-nowrap cursor-pointer"
            >
              了解我们
            </Link>
            <Link
              to="/news"
              className="inline-flex items-center gap-2 h-11 px-5 rounded-md border border-background-100/40 font-label text-sm font-semibold text-background-50 hover:bg-background-50/10 transition-colors whitespace-nowrap cursor-pointer"
            >
              查看最新资讯
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-2 border-t lg:border-t-0 lg:border-l border-background-100/15">
          {stats.map((s) => (
            <div key={s.label} className="p-6 md:p-8 border-b border-background-100/15 even:border-l border-background-100/15">
              <p className="font-heading text-3xl md:text-4xl font-extrabold text-accent-400">{s.value}</p>
              <p className="mt-2 text-sm text-background-200/80">{s.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}